module.exports = require("underscore");


/*****************
 ** WEBPACK FOOTER
 ** external "underscore"
 ** module id = 15
 ** module chunks = 0
 **/